import { c as _c } from "react/compiler-runtime";
import { Box, chakra, HTMLChakraProps } from '@chakra-ui/react';
import { useHover } from '@uidotdev/usehooks';
import * as React from 'react';
export const AppLayoutResizeHandle: React.FC<HTMLChakraProps<'div'>> = props => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      cursor: "col-resize",
      userSelect: "none",
      paddingX: "5px",
      marginX: "-5px",
      zIndex: 1,
      boxShadow: "none"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const styles = t0;
  const [ref] = useHover();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      __css: styles
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = ref as any;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box appearance="none" bgColor="transparent" cursor="ew-resize" fontSize="0" height="full" padding="0" position="relative" transform="translateX(-50%)" transition="all 0.1s ease-in" _after={{
      bgColor: "transparent",
      content: "\"\"",
      height: "100%",
      left: "-5px",
      opacity: "0.6",
      position: "absolute",
      top: "0%",
      transition: "0.3s ease-out",
      width: "10px",
      zIndex: "-1"
    }} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props || $[4] !== t2) {
    t4 = <chakra.div zIndex={99} {...props} {...t1 as any} ref={t2}>{t3}</chakra.div>;
    $[3] = props;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};